import * as React from "react";
import Lottie from "react-lottie";
import { BodyLoading, Container, ModalLoading } from "./style";
import animationData from "../../assets/animations/animation_infinity.json";

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      // preserveAspectRatio: "xMidYMid slice"
    }
  };

const Animation = () => {
  return (
    <ModalLoading>
        <BodyLoading>
          <Container>
            <Lottie
              options={defaultOptions} height={200} width={200}
            />
          </Container>
        </BodyLoading>
    </ModalLoading>
  );
};

export default Animation;